import Skeleton from '../../models/skeleton'

export default class ReportSkeleton extends Skeleton {
  get defaults () {
    return {
      id: -1,
      name: 'Untitled',
      report_type: 'skeleton',
      state: 'finished',
      metrics: {
        participant_count: 0
      }
    }
  }

  get polls () {
    return new Backbone.Collection()
  }

  get skeleton () {
    return true
  }

  type () {
    return 'skeleton'
  }

  typeName () {
    return 'skeleton'
  }

  description () {
    return 'skeleton'
  }
}
